import React, { useEffect, useState } from "react";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import InputSelect from "../../../components/InputSelect";
import InputDate from "../../../components/InputDate";

import { DOCUMENT_MODELS, DOCUMENT_STATUSES } from "../helpers";

/**
 * Filtros avançados das notas emitidas (BDM-887).
 *
 * Mesmo padrão das demais listas (Product/Finance): estado local hidratado da
 * URL ao abrir, "Aplicar"/"Limpar" devolvem para a lista, que navega. A busca
 * por número/chave continua no campo do topo, não aqui.
 */
export const ModalFilter = ({ show, close, filters, setCustomFilters, issuers = [] }) => {
    const [status, setStatus] = useState('');
    const [model, setModel] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {
        if (!show) return;

        setStatus(filters.status);
        setModel(filters.model);
        setCompanyId(filters.companyId);
        setStartDate(filters.startDate);
        setEndDate(filters.endDate);
    }, [show, filters]);

    const apply = () => {
        setCustomFilters({ status, model, companyId, startDate, endDate });
        close();
    };

    const clear = () => {
        setCustomFilters({ status: '', model: '', companyId: '', startDate: '', endDate: '' });
        close();
    };

    // Só faz sentido escolher o emitente quando existe mais de um.
    const issuerOptions = issuers.map(issuer => ({
        label: issuer.trade_name ?? issuer.company_name,
        value: issuer.id,
    }));

    return (
        <Modal
            title={`Filtrar notas`}
            show={show}
            close={close}
            footer={
                <>
                    <Button type={`secondary`} size={`small`} text={`Limpar filtros`} action={clear} />
                    <Button type={`primary`} size={`small`} text={`Aplicar`} action={apply} />
                </>
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col-6">
                        <InputSelect
                            menuInBody
                            label={`Situação`}
                            options={[{ label: 'Todas', value: '' }, ...DOCUMENT_STATUSES]}
                            value={status}
                            change={setStatus}
                        />
                    </div>
                    <div className="col-6">
                        <InputSelect
                            menuInBody
                            label={`Tipo de nota`}
                            options={[{ label: 'Todos', value: '' }, ...DOCUMENT_MODELS]}
                            value={model}
                            change={setModel}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-6">
                        <InputDate label={`Emissão de`} format={`YYYY-MM-DD`} value={startDate} change={setStartDate} />
                    </div>
                    <div className="col-6">
                        <InputDate label={`Emissão até`} format={`YYYY-MM-DD`} value={endDate} change={setEndDate} />
                    </div>
                </div>

                {issuerOptions.length > 1 &&
                    <div className="row">
                        <div className="col-12">
                            <InputSelect
                                menuInBody
                                label={`Empresa emitente`}
                                options={[{ label: 'Todas', value: '' }, ...issuerOptions]}
                                value={companyId}
                                change={setCompanyId}
                            />
                        </div>
                    </div>
                }
            </div>
        </Modal>
    );
};

export default ModalFilter;
